
const dateFormat = require('bmh/date-format');
import { Component, Vue } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const _ = {
  uniqBy: require('lodash/uniqBy')
};
const qs = require('qs');

enum enumMergeDialog {
  choose_company,
  confirm_data
}

const API = {
  get_follower_list: `${FCAPI}/boss/hundun/company/follower`,
  get_list: `${FCAPI}/boss/hundun/company`,
  post_merge: `${FCAPI}/boss/hundun/company/merge`,
  post_follower: `${FCAPI}/boss/hundun/company/followerrele`,
  delete_follower: `${FCAPI}/boss/hundun/company/followerrele/0`,
  post_status: `${FCAPI}/boss/hundun/company/status`,
  repeal_data: `${FCAPI}/boss/hundun/company/tob/`,
  user_list: `${FCAPI}/boss/hundun/user`,
  add_log: `${FCAPI}/boss/hundun/company/log`,
  put_follower: `${FCAPI}/boss/hundun/company/followerrele/`
};

const employees_table: any = {
  '0': {
    employees_number_floor: 0,
    employees_number_ceil: 50
  },
  '1': {
    employees_number_floor: 51,
    employees_number_ceil: 100
  },
  '2': {
    employees_number_floor: 101,
    employees_number_ceil: 500
  },
  '3': {
    employees_number_floor: 501,
    employees_number_ceil: 100000
  }
};

function initForm() {
  return {
    is_all: 0, //默认分页，传1表示不分页
    current: 1,
    is_export: 0, //是否导出
    limit: 20,
    full_or_part_name: '',
    location: '',
    industry: '',
    employees_number_floor: '',
    employees_number_ceil: '',
    cooperation_state: -2,
    college: '',
    is_tob: 1,
    remark: '',
    user_mobile: '',
    is_exist_order: '',
    order_count: '',
    begin_start_time: [],
    finish_start_time: [],
    present_follower_id: [],
    follow_up_content: '',
    is_keyman: undefined
  };
}

function validateMapFormat() {
  return {
    full_name: {
      value: '',
      status: '',
      help: ''
    },
    standard: {
      value: '',
      status: '',
      help: ''
    }
  };
}

// function initMergeFrom() {
//   return {
//     full_name: '',
//     location: '',
//     industry: '',
//   }
// }

@Component
export default class TubiCompany extends Vue {
  form_merge_company: any;
  more_change_form: any;
  form = initForm();
  merge_from: any = initForm();
  employees_id: any = '';
  is_loading = false;
  locale = zhCN;
  table_data: any = {};
  table_data_merge: any = {};
  select_row_key = [];
  select_row_data = []; //已选择的具体数据
  merge_select_row_data = []; //已选择的具体数据
  merge_select_row_key = [];
  more_change = [
    {
      id: 1,
      value: '跟进状态'
    },
    {
      id: 2,
      value: '目前跟进人'
    }
  ];
  show_add_tag = false; // 添加标签弹框
  more_id = -1; //批量修改类型选择www
  merge_dialog = false;
  enumMergeDialog = enumMergeDialog;
  merge_dialog_type = enumMergeDialog.choose_company;
  follower_list: any = [];
  cooperation_type_map = [
    { name: '请选择', id: -2 },
    { name: '暂无明确需求，持续跟进', id: 1 },
    { name: '待匹配合作方案', id: 2 },
    { name: '已出合作方案待回复', id: 4 },
    { name: '待签约', id: 5 },
    { name: '已合作', id: 3 },
  ];
  merge_indeterminate = false;
  merge_checked = false;
  user_table: any = {};
  show_students_dialog = false;
  select_students_name = '';
  choose_students_data: any = {};
  validate_map: any = validateMapFormat();
  selectedCompanies: any = 0;
  select_row_data_user_number: any = 0;
  current = 0;

  async handleRepealTubi() {
    if (!this.select_row_key.length) {
      this.$message.error('请先勾选要撤销兔必的企业');
      return;
    }
    const res: any = await this.$axios.delete(`${API.repeal_data}0?id_list=${this.select_row_key.toString()}`);
    if (res.data.status === 200) {
      this.init();
      this.$message.success('撤销成功');
      this.select_row_key = [];
      this.select_row_data_user_number = 0;
      return;
    }

    console.log(this.select_row_key);
  }

  //翻页
  changePageMerge(page: any) {
    this.initMerge(page.current);
  }
  //翻页
  changePage(page: any) {
    this.current = page.current;
    this.init(page.current);
  }

  handleChooseAllMerge() {
    if (this.merge_select_row_key.length === this.table_data_merge.detail.length) {
      this.merge_checked = false;
      this.merge_indeterminate = false;
      this.merge_select_row_key = [];
      this.merge_select_row_data = [];
    } else {
      this.merge_select_row_key = this.table_data_merge.detail.map((item: any) => item.id);
      this.merge_select_row_data = this.table_data_merge.detail;
      this.merge_checked = true;
      this.merge_indeterminate = false;
    }
    console.log(this.merge_select_row_key);
  }

  // 批量修改弹框
  changeMore() {
    if (this.select_row_data.length === 0) {
      this.$message.error('请先勾选要批量修改的企业');
      return;
    }
    this.more_change_form.resetFields(),
      // this.button_type = 3;
      (this.more_id = -1);
    this.show_add_tag = true;
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d');
  }

  async search(page = 1) {
    this.form_merge_company.resetFields(['full_name', 'standard']);
    if (this.employees_id) {
      this.form.employees_number_floor = employees_table[this.employees_id].employees_number_floor;
      this.form.employees_number_ceil = employees_table[this.employees_id].employees_number_ceil;
    } else {
      this.form.employees_number_floor = '';
      this.form.employees_number_ceil = '';
    }
    this.init(page);
    console.log(this.form);
  }

  async exportData(page = 1) {
    this.form_merge_company.resetFields(['full_name', 'standard']);
    if (this.employees_id) {
      this.form.employees_number_floor = employees_table[this.employees_id].employees_number_floor;
      this.form.employees_number_ceil = employees_table[this.employees_id].employees_number_ceil;
    } else {
      this.form.employees_number_floor = '';
      this.form.employees_number_ceil = '';
    }
    const begin_start_time = this.form.begin_start_time[0] ? Math.floor((this.form.begin_start_time[0] as any).hours(23).minutes(59).seconds(59) / 1000) : '';
    const finish_start_time = this.form.begin_start_time[1] ? Math.floor((this.form.begin_start_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
    const begin_end_time = this.form.finish_start_time[0] ? Math.floor((this.form.finish_start_time[0] as any).hours(23).minutes(59).seconds(59) / 1000) : '';
    const finish_end_time = this.form.finish_start_time[1] ? Math.floor((this.form.finish_start_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
    const url = `${API.get_list}?${qs.stringify({
      ...this.form,
      present_follower_id: this.form.present_follower_id.toString(),
      begin_start_time,
      finish_start_time,
      begin_end_time,
      finish_end_time,
      current: this.table_data.current,
      is_export: 1,
      is_all: 1,
      limit: undefined,
      is_tob: 1
    })}`;
    // const url = getUrl(API.get_list, {...this.merge_from, current: this.table_data.current, is_export: 1, is_all: 1});
    const res: any = await this.$axios.get(url);
    if (res.data.status === 200) {
      window.location.href = url;
    }
  }

  onSelectChange(select_row_key: any, value: any) {
    let number: any = 0;
    value.forEach((element: any) => {
      number = number + element.user_number;
    });
    this.select_row_data_user_number = number;

    this.select_row_data = value;
    this.select_row_key = select_row_key;
  }

  //分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }

  handleClear() {
    this.form = initForm();
    this.employees_id = undefined;
    // this.init(1);
  }

  handleClearMerge() {
    this.merge_from = initForm();
    // this.initMerge(1);
  }

  changeMoretype(id: number) {
    this.more_id = id;
    console.log(this.more_id);
  }

  async init(page = 1) {
    const begin_start_time = this.form.begin_start_time[0] ? Math.floor((this.form.begin_start_time[0] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const finish_start_time = this.form.begin_start_time[1] ? Math.floor((this.form.begin_start_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const begin_end_time = this.form.finish_start_time[0] ? Math.floor((this.form.finish_start_time[0] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const finish_end_time = this.form.finish_start_time[1] ? Math.floor((this.form.finish_start_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const res: any = await this.$axios.get(
      `${API.get_list}?${qs.stringify({
        ...this.form,
        current: page,
        present_follower_id: this.form.present_follower_id.toString(),
        begin_start_time,
        finish_start_time,
        begin_end_time,
        finish_end_time
      })}`
    );
    // const url = getUrl(API.get_list, {
    //   ...this.form,
    //   current: page,
    //   present_follower_id: this.form.present_follower_id.toString(),
    //   begin_start_time,
    //   finish_start_time,
    //   begin_end_time,
    //   finish_end_time,
    // });
    // const res: any = await this.$axios.get(url);
    if (res.data.data) {
      res.data.data.detail.forEach((element: any) => {
        element.follower_separate = element.follower_separate.map((item: any) => item.follower_id);
      });
    }
    this.table_data = res.data.data ? res.data.data : [];
    this.select_row_key = [];
  }

  async initMerge(page = 1) {
    const url = getUrl(API.get_list, {
      ...this.merge_from,
      current: page,
      full_or_part_name: this.merge_from.full_name,
      full_name: undefined,
      limit: 10
    });
    const res: any = await this.$axios.get(url);
    this.table_data_merge = res.data.data ? res.data.data : [];
  }

  cancel() {
    this.show_add_tag = false;
  }

  submit() {
    this.more_change_form.validateFields(async (err: any, values: any) => {
      if (!err) {
        for (let item in values) {
          if (values[item] === undefined) {
            values[item] = null;
          }
        }
        console.log(values);
        this.axiosCooperation(this.select_row_key, values['status']);
        const post_list: any = [];
        this.select_row_key.forEach((e: any) => {
          post_list.push(
            this.$axios.put(`${API.put_follower}${e}`, {
              follower_id_list: values['follow']
            })
          );
        });
        await Promise.all(post_list);
        this.merge_select_row_data = [];
        this.merge_select_row_key = [];
        // console.log(values);
        // if (this.more_id === 0) {
        //   this.axiosCooperation(this.select_row_key, values.second);
        // } else {
        //   const post_list: any = [];
        //   this.select_row_key.forEach((e: any) => {
        //     post_list.push(
        //       this.$axios.put(`${API.put_follower}${e}`, {
        //         follower_id_list: values.second
        //       })
        //     );
        //   });
        //   await Promise.all(post_list);
        //   this.merge_select_row_data = [];
        //   this.merge_select_row_key = [];
        // }
        this.show_add_tag = false;
        this.init(this.current);
        this.select_row_key = [];
        this.select_row_data = [];
      }
    });
    console.log(this.more_change_form.validateFields());
    console.log(this.form_merge_company);
  }

  mergeNext() {
    if (this.merge_select_row_key.length > 1) {
      const merge_send_data: any = [];
      this.merge_select_row_key.forEach((element: any) => {
        merge_send_data.push(this.merge_select_row_data.filter((elements: any) => elements.id === element)[0]);
      });
      this.merge_select_row_data = merge_send_data;
      this.merge_dialog_type = enumMergeDialog.confirm_data;
    } else {
      this.$message.error('请选择最少两个企业');
    }
    console.log(this.merge_select_row_key);
  }

  mergeSubmit() {
    let is_valid = true;
    if (!this.validate_map.full_name.value) {
      this.validate_map.full_name.status = 'error';
      this.validate_map.full_name.help = '请输入合并后的全称';
      console.log(this.validate_map.full_name.value);

      is_valid = false;
    }
    if (!this.validate_map.standard.value) {
      this.validate_map.standard.status = 'error';
      this.validate_map.standard.help = '请选择合并标准';
      is_valid = false;
    }
    if (!is_valid) {
      return;
    }
    this.form_merge_company.validateFields(async (err: any, values: any) => {
      if (!err) {
        const send_data = {
          master_id: this.validate_map.standard.value,
          slave_id_list: this.merge_select_row_key.filter((item) => item !== this.validate_map.standard.value),
          full_name: this.validate_map.full_name.value
        };
        const res: any = await this.$axios.post(API.post_merge, send_data);
        this.merge_dialog = false;
        this.init(this.table_data.current);
        console.log(values);
      }
    });
  }

  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  mergeCancel() {
    this.merge_dialog = false;
  }

  handleShowMergeDialog() {
    this.merge_select_row_data = [];
    this.merge_select_row_key = [];
    this.validate_map = validateMapFormat();
    this.merge_dialog_type = enumMergeDialog.choose_company;
    this.merge_dialog = true;
    this.merge_checked = false;
    this.merge_indeterminate = false;
    this.merge_from = initForm();
    this.initMerge(1);
  }

  mergeOnSelectChange(select_row_key: any, value: any) {
    this.merge_select_row_key = select_row_key;
    const select_data = [...this.merge_select_row_data, ...value];
    this.merge_select_row_data = _.uniqBy(select_data, (e: any) => {
      return e.id;
    });
    if (this.merge_select_row_key.length === this.table_data_merge.detail.length) {
      this.merge_indeterminate = false;
      this.merge_checked = true;
      return;
    }
    if (this.merge_select_row_key.length) {
      this.merge_indeterminate = true;
    } else {
      this.merge_indeterminate = false;
      this.merge_checked = false;
    }
  }

  beforeCreate() {
    this.form_merge_company = this.$form.createForm(this);
    this.more_change_form = this.$form.createForm(this);
  }

  handleView(record: any) {
    console.log(record);
    this.$router.push({
      path: '/hundun/company-detail',
      query: { id: record.id, name: record.full_name }
    });
  }

  async initFollower() {
    const send_data = {
      current: 1,
      limit: 999999,
      weixin_nickname: '',
      mobile: '',
      charge: '',
      status: 0
    };
    const url = getUrl(API.get_follower_list, send_data);
    const res: any = await this.$axios.get(url);
    this.follower_list = res.data.data
      ? [
        ...res.data.data.detail,
        {
          weixin_nickname: '无',
          id: 0
        }
      ]
      : [
        {
          weixin_nickname: '无',
          id: 0
        }
      ];
  }

  async handleEditFollower(value: any, record: any, is_delete: any = false) {
    const follower_name: any = this.follower_list.filter((item: any) => {
      return item.id === value;
    })[0];
    console.log(follower_name.weixin_nickname);
    const res: any = is_delete
      ? await this.$axios.delete(`${API.delete_follower}?company_id=${record.id}&follower_id=${value}`)
      : await this.$axios.post(API.post_follower, {
        company_id: record.id,
        follower_id: value,
        follower_name: follower_name.weixin_nickname
      });
    if (res.data.status === 200) {
      this.$message.success('修改成功');
    }
  }

  async axiosCooperation(list: any, id: number) {
    const res: any = await this.$axios.post(API.post_status, {
      id_list: list,
      cooperation_state: id
    });
    if (res.data.status === 200) {
      this.$message.success('修改成功');
    }
  }

  async addLog(log: any, item: any) {
    if (!log) {
      this.$message.error('请输入备注');
      return;
    }
    const send_data = {
      company_id: item.id,
      content: `备注  “${log}”`
    };
    const res: any = await this.$axios.post(API.add_log, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      item.explain = '';
    }
  }

  async initUser(page = 1) {
    const send_data = {
      current: page,
      limit: 10,
      corp_name: this.choose_students_data.full_name,
      sort: 'keyman'
    };
    const url = getUrl(API.user_list, send_data);
    const res: any = await this.$axios.get(url);
    this.user_table = res.data.data ? res.data.data : [];
  }

  handleShowStudents(item: any) {
    this.select_students_name = `${item.full_name}/`;
    this.user_table = {};
    this.choose_students_data = item;
    this.show_students_dialog = true;
    this.initUser(1);
  }

  //翻页
  changeUserPage(page: any) {
    this.initUser(page.current);
  }

  created() {
    this.init();
    this.initFollower();
  }
}
